export const CategoriesEndpoints = {
  getCategoriesOptions: 'getCategoriesOptions',
} as const;
